import { isEmpty, isNull } from "lodash";
import React from "react";
import {
  DISPLAY_SYS_GUARD_ALERT_COMMENT,
  maskedUsernameLoc,
  SAVE_SYS_GUARD_COMMENT,
  SET_SYS_GUARD_ALERT_COMMENT,
} from "../../sysGuardConstants";
import { useDispatch, useSelector } from "react-redux";
import { maskUsername } from "../../SysGuardCommonComp";
import TextField from "@material-ui/core/TextField";
import DoneIcon from "@material-ui/icons/Done";
import { updateAlertStatus } from "../../../../redux/actions/updateAlertStatusAction";
import { DeleteButtonForToolBar } from "../../../../components/common/buttons";
import ClearIcon from "@material-ui/icons/Clear";

const SysGuardInfoBox = ({ data, loc, parentData }) => {
  const isIncognito = useSelector((state) => state.SysGuardReducer.incognito);
  const alertComment = useSelector(
    (state) => state.SysGuardReducer.alertComment
  );
  const displayAlertComment = useSelector(
    (state) => state.SysGuardReducer.displayAlertComment
  );
  const alertStatus = useSelector((state) => state.SysGuardReducer.alertStatus);
  const dispatch = useDispatch();
  const alertInfo = data?.alertInfo;
  const alertId = data?.alertId;
  const ipInfo = data?.clientIp;
  // const ticketIds = data?.ticketIds; //This is commented out for now, we will use this in the future
  const userNameInfo =
    isIncognito && maskedUsernameLoc.includes(loc)
      ? maskUsername(data?.userName)
      : data?.userName;

  const handleNewComment = (e) => {
    const comment = e.target.value;
    dispatch({ type: SET_SYS_GUARD_ALERT_COMMENT, payload: comment });
  };

  const handleSaveComment = () => {
    if (!isEmpty(alertComment) || !isNull(alertComment)) {
      dispatch({
        type: SAVE_SYS_GUARD_COMMENT,
        payload: { id: alertId, comment: alertComment },
      });
    }
    dispatch(
      updateAlertStatus({
        status: alertStatus,
        ids: [`${alertId}`],
        sysGuardData: parentData,
      })
    );
    dispatch({
      type: DISPLAY_SYS_GUARD_ALERT_COMMENT,
      payload: false,
    });
  };

  const renderCommentSection = () => {
    return (
      <div className="sys-guard-alert-box-container">
        <TextField
          id="outlined-multiline-static"
          multiline
          rows={4}
          placeholder="Add Comments or Continue"
          variant="outlined"
          value={alertComment}
          onChange={(e) => handleNewComment(e)}
          style={{ width: "100%" }}
        />
        <div className="alert-button-container">
          <DeleteButtonForToolBar
            style={{ float: "right" }}
            variant="contained"
            id="delete"
            size="small"
            color="primary"
            onClick={() => handleSaveComment()}
            className="min-margin"
          >
            <DoneIcon />
          </DeleteButtonForToolBar>
          <DeleteButtonForToolBar
            style={{ float: "right" }}
            variant="contained"
            id="delete"
            size="small"
            color="primary"
            onClick={() => {
              dispatch({
                type: DISPLAY_SYS_GUARD_ALERT_COMMENT,
                payload: false,
              });
              dispatch({
                type: SET_SYS_GUARD_ALERT_COMMENT,
                payload: null
              })
            }}
            className="min-margin"
          >
            <ClearIcon />
          </DeleteButtonForToolBar>
        </div>
      </div>
    );
  };

  const renderInfoBox = () => {
    if (displayAlertComment) {
      return renderCommentSection();
    }

    return (
      <div className="parent-container">
        {loc === "locationBasedAnomalies" || loc === "cityBasedAnomalies" ? (
          <div className="child-container-two">
            <div className="child-container">
              <div className="para-name">User Name:</div>
              <div>{userNameInfo}</div>
            </div>

            <div className="child-container">
              <div className="para-name">IP Address:</div>
              <div>{ipInfo}</div>
            </div>
          </div>
        ) : null}

        <div className="child-container">
          <div className="para-name">Alert Information:</div>
          <div>{alertInfo}</div>
        </div>
      </div>
    );
  };

  return (
    <div className="sys-guard-info-box">
      <h2>Alert Details</h2>
      {!isNull(alertInfo) && alertInfo ? (
        renderInfoBox()
      ) : (
        <div>Select a row to view alert information.</div>
      )}
    </div>
  );
};

export default SysGuardInfoBox;
